import React from 'react';
import { useStateValue } from '../context/state.jsx';

const LoadingOverlay = () => {
	const [{ ajaxRequests }] = useStateValue();
	return Object.keys(ajaxRequests).length > 0
		? (
			<div className="overlayScreen loadingOverlayScreen">
				<div className="overlayContent loadingOverlayContent">
					<div className="loadingOverlaySpinnerIcon"></div>
					<div className="loadingOverlayText">Loading...</div>
				</div>
			</div>
		)
		: null;
};

export default LoadingOverlay;